export const t = {
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Apagar',
    add: 'Adicionar',
    loading: 'A carregar…',
    error: 'Erro',
    search: 'Pesquisar',
    back: 'Voltar',
    continue: 'Continuar',
    submit: 'Submeter',
    confirm: 'Confirmar',
    required: 'Obrigatório',
    breadcrumb: 'Navegação',
  },
  nav: {
    home: 'Início',
    products: 'Produtos',
    cart: 'Carrinho',
    account: 'A minha conta',
    login: 'Entrar',
    register: 'Registar',
    logout: 'Terminar sessão',
    admin: 'Administração',
    homepage: 'HOMEPAGE',
    about: 'SOBRE A ROSITA',
    shop: 'LOJA',
    search: 'Pesquisar',
    wishlist: 'Favoritos',
    cartAria: 'Carrinho',
    menu: 'Menu',
    close: 'Fechar',
  },
  home: {
    heroWelcome: 'Bem-vindas à',
    heroBrand: 'Rosita Store',
    heroTagline: 'Criada a pensar em ti',
    heroBody:
      'Peças femininas pensadas para o teu dia a dia. Conforto, estilo e autenticidade numa só loja.',
    heroCta: 'VER NOVIDADES',
    collectionTitle: 'Tudo o que precisas,',
    collectionTitleAccent: 'num só lugar',
    collectionBody:
      'Peças versáteis e confortáveis, pensadas para o quotidiano de mulheres reais. Porque a moda deve acompanhar a tua vida, não o contrário.',
    collectionCta: 'VER NOVIDADES',
    detailsEyebrow: 'PARA A MULHER REAL',
    detailsTitleLine1: 'CADA',
    detailsTitleLine2: 'DETALHE',
    detailsTitleLine3: 'IMPORTA',
    detailsBody:
      'Na Rosita cada peça é escolhida a pensar em ti. Conforto, qualidade e um toque especial em tudo o que encontras na nossa loja.',
    positivesTitle: 'Pensado',
    positivesTitleAccent: 'para ti',
    positivesTitleSuffix: ', do início ao fim',
    positivesBody:
      'Desde a escolha das peças até à entrega em tua casa, cada passo é pensado para que a tua experiência seja simples, segura e sem preocupações',
    positives: {
      curatedTitle: 'Peças selecionadas com cuidado',
      humanTitle: 'Atendimento próximo e humano',
      shippingTitle: 'Envio para todo o país',
    },
    closingTitle: 'Pronta para te sentires',
    closingTitleAccent: 'tu',
    closingTitleSuffix: '?',
    closingBody: 'Entra, explora e encontra as peças que já estavam à tua espera.',
    closingCta: 'VER NOVIDADES',
    stripAlt: 'Coleção Rosita',
  },
  about: {
    title: 'Sobre a Rosita',
    breadcrumbCurrent: 'Sobre a Rosita',
    eyebrow: 'A NOSSA HISTÓRIA',
    script: 'vista-se de si e brilhe',
    storyTitleA: 'Feita com ',
    storyTitleAccent: 'raízes',
    storyTitleB: ' e alma',
    storyLead: 'Uma homenagem que se tornou identidade.',
    storyParagraphs: [
      'O nome "Rosita" veio do coração da família. Uma homenagem à bisavó Rosa, uma mulher de raízes sólidas, força silenciosa e uma delicadeza que nunca passa de moda.',
      'O que começou como um projeto familiar, cresceu no digital com intenção. E continua a crescer, cada vez mais longe.',
      'Acreditamos que a moda feminina é mais do que roupa. É confiança. É a forma como entras numa divisão e sentes que estás exatamente onde queres estar.',
    ],
    valuesTitle: 'Os nossos',
    valuesTitleAccent: 'valores',
    values: [
      {
        title: 'Confiança',
        body: 'Cada peça foi pensada para que te sintas segura e inteira, por dentro e por fora.',
      },
      {
        title: 'Conforto',
        body: 'Porque sentires-te bem é a base de tudo o resto.',
      },
      {
        title: 'Versatilidade',
        body: 'Peças que se adaptam ao teu dia, ao teu ritmo, à tua vida.',
      },
      {
        title: 'Autenticidade',
        body: 'Somos o que dizemos ser. Sem filtros, sem máscaras.',
      },
      {
        title: 'Transparência',
        body: 'Comunicamos sempre de forma clara, próxima e honesta.',
      },
      {
        title: 'Produção',
        body: 'Peças de ótima qualidade, pensadas para te acompanhar mais tempo.',
      },
    ],
    closingTitleA: 'Encontra as peças',
    closingTitleB: 'feitas ',
    closingTitleAccent: 'para ti',
    closingTitleC: '.',
    cta: 'VER A COLEÇÃO',
  },
  products: {
    breadcrumbHome: 'INÍCIO',
    breadcrumbShop: 'LOJA',
    title: 'LOJA',
    clearFilters: 'Limpar Filtros',
    applyFilters: 'APLICAR FILTROS',
    openFilters: 'Filtros',
    closeFilters: 'Fechar',
    filterGroupProducts: 'Produtos',
    filterGroupSize: 'Tamanho',
    filterGroupColour: 'Cor',
    filterGroupMaterial: 'Material',
    filterGroupPrice: 'Preço',
    all: 'Todas',
    allMaterials: 'Todos',
    sortBy: 'Ordenar por',
    resultsCount: 'produtos',
    noResults: 'Sem produtos para os filtros selecionados.',
    badgeNew: 'NOVO!',
    badgeOut: 'ESGOTADO',
    minPrice: 'Min',
    maxPrice: 'Max',
  },
  product: {
    addToCart: 'ADICIONAR',
    outOfStock: 'Sem stock',
    size: 'Tamanho',
    colour: 'Cor',
    quantity: 'Quantidade',
    description: 'Descrição',
    selectVariant: 'Seleciona tamanho e cor',
    inStock: 'Em stock',
    lowStock: 'Últimas unidades',
    chooseColour: 'Escolhe uma cor',
    chooseSize: 'Escolhe um tamanho',
    addToWishlist: 'Adicionar aos favoritos',
    descriptionLabel: 'DESCRIÇÃO',
    detailsLabel: 'DETALHES',
    detailsWeight: 'Peso',
    detailsComposition: 'Composição',
    measurementsLabel: 'MEDIDAS',
    sizeGuide: 'Guia de medidas',
    measurementsPoint: 'Medida (cm)',
    measurementsHint:
      'Escolhe o teu tamanho para o destacarmos na tabela. Medidas em centímetros, tiradas com a peça em plano; podem variar 1 a 2 cm.',
    shippingReturnsLabel: 'ENTREGAS E DEVOLUÇÕES',
    // Deliberately free of hard numbers for cost and delivery time: those
    // differ per zone (2-3 dias no Continente, 5-7 nas ilhas) and live in the
    // backoffice, so the accordion links to /entregas-e-devolucoes instead of
    // repeating figures that go stale.
    shippingReturnsBody:
      'Enviamos para todo o país e o custo do envio é calculado ao finalizares a compra. Tens 14 dias para devolver, a contar da data em que recebes a encomenda.',
    shippingReturnsLink: 'Ver custos, prazos e como devolver',
    relatedScript: 'também podes gostar',
    relatedEyebrow: 'PODERÁS TAMBÉM GOSTAR',
  },
  cart: {
    title: 'O teu carrinho',
    empty: 'O teu carrinho está vazio — mas não tem de ser assim.',
    shopNow: 'Ver loja',
    subtotal: 'Subtotal',
    shipping: 'Portes',
    discount: 'Desconto',
    total: 'Total',
    checkout: 'Finalizar compra',
    remove: 'Remover',
    couponPlaceholder: 'Código de desconto',
    applyCoupon: 'Aplicar',
    couponApplied: 'Cupão aplicado',
    couponInvalid: 'Cupão inválido',
    added: 'Adicionado ao Carrinho',
    viewCart: 'Ver carrinho',
  },
  checkout: {
    title: 'Finalizar compra',
    steps: {
      details: 'Detalhes',
      shipping: 'Envio',
      payment: 'Pagamento',
      confirmation: 'Confirmação',
    },
    guestContinue: 'Continuar como convidado',
    loginContinue: 'Entrar na minha conta',
    guestGateTitle: 'Já tens conta?',
    guestGateLead: 'Entra para finalizar mais depressa ou continua como convidada.',
    guestGateLogin: 'Entrar',
    guestGateLoginHint: 'Já sou cliente Rosita',
    guestGateGuest: 'Continuar como convidada',
    guestGateGuestHint: 'Finalizo a compra sem criar conta',
    guestGateRegister: 'Ainda não tens conta?',
    guestGateRegisterCta: 'Criar conta',
    firstName: 'Nome',
    lastName: 'Apelido',
    email: 'Email',
    phone: 'Telemóvel',
    nif: 'NIF (opcional, para fatura)',
    address1: 'Morada',
    address2: 'Morada (linha 2)',
    city: 'Localidade',
    postalCode: 'Código postal',
    district: 'Distrito',
    country: 'País',
    useShippingAsBilling: 'Usar a mesma morada para faturação',
    savedAddressesTitle: 'Morada de entrega',
    savedAddressDefaultBadge: 'Padrão',
    newAddressOption: 'Usar outra morada',
    billingTitle: 'Faturação',
    billingDifferentToggle: 'Faturar para uma morada diferente',
    billingSavedTitle: 'Morada de faturação',
    paymentMethod: 'Método de pagamento',
    mbway: 'MB WAY',
    multibanco: 'Multibanco (referência)',
    creditCard: 'Cartão de crédito',
    mbwayPhone: 'Telemóvel MB WAY',
    cardSessionLoading: 'A preparar o formulário seguro…',
    cardAlreadyPaid: 'Esta encomenda já foi paga.',
    cardSessionExpired: 'A sessão de pagamento expirou. Tenta de novo.',
    cardPaymentRetry: 'Não foi possível concluir o pagamento. Verifica os dados e tenta novamente.',
    customerNotes: 'Notas para a loja (opcional)',
    implicitTermsPrefix: 'Ao concluir o pagamento, aceitas os',
    implicitTermsJoin: ' e a ',
    implicitTermsLinks: {
      terms: 'Termos e Condições',
      privacy: 'Política de Privacidade',
    },
    placeOrder: 'Concluir encomenda',
    continueToPayment: 'Continuar para pagamento',
    payNow: 'Efetuar pagamento',
    choosePaymentMethod: 'Escolhe o teu método de pagamento:',
    noPaymentMethods: 'De momento não há métodos de pagamento disponíveis. Volta mais tarde.',
    backToDetails: 'Voltar aos detalhes',
    summary: 'Resumo',
    pageTitleStep2: 'Pagamento',
    shippingMethodTitle: 'Método de envio',
    shippingNoRates: 'Sem portes disponíveis para este código postal.',
    shippingHint: 'Introduza o código postal para calcular portes.',
    errorSelectShippingRate: 'Selecione um método de envio',
    pickupInStore: 'Ponto de recolha',
    pickupFree: 'Recolha gratuita',
    pickupDeadlineDays: 'Levante a sua encomenda até {days} dias após o pagamento',
    pickupDeadlineLabel: 'Levantar até',
    pickupOptionAddress: 'Local',
    pickupConfirmTitle: 'Ponto de recolha',
    pickupGroupTitle: 'Ponto de recolha',
    deliveryGroupTitle: 'Receber em casa',
    errorShippingFailed: 'Falha ao calcular portes',
    errorPaymentFailed: 'Falha ao processar pagamento',
    free: 'Grátis',
    vatLineLabel: 'dos quais IVA ({rate}%)',
    secureNotice: 'Pagamento seguro',
    returnsNotice: 'Devolução em 14 dias',
    viewSummary: 'Ver resumo',
    hideSummary: 'Ocultar resumo',
    paymentMethodsLabel: 'Aceitamos',
    mbwayPending: 'Abre a aplicação MB WAY no teu telemóvel e confirma o pagamento.',
    mbwayWindowHint: 'Tens cerca de 4 minutos para aprovar.',
    mbwayTimerLabel: 'Tempo restante',
    mbwayPolling: 'À espera da confirmação do MB WAY…',
    mbwayPaidTitle: 'Pagamento confirmado!',
    mbwayPaidDescription: 'Recebemos a confirmação do MB WAY. Vais receber um email com os detalhes da tua encomenda.',
    mbwayExpiredTitle: 'O tempo para aprovar terminou',
    mbwayExpiredDescription: 'Não recebemos a confirmação do MB WAY a tempo. Podes tentar novamente a partir da tua conta.',
    multibancoRefTitle: 'Pague por referência Multibanco',
    multibancoEntity: 'Entidade',
    multibancoReference: 'Referência',
    multibancoAmount: 'Montante',
    thankYou: 'Obrigado pela sua encomenda!',
    orderNumber: 'Número de encomenda',
  },
  account: {
    dashboard: 'Resumo',
    orders: 'Encomendas',
    profile: 'Perfil',
    addresses: 'Moradas',
    email: 'Email',
    emailHint: 'O email da tua conta não pode ser alterado.',
    noOrders: 'Ainda não fizeste nenhuma encomenda.',
    viewOrder: 'Ver detalhes',
    downloadInvoice: 'Descarregar fatura',
    changePassword: 'Alterar palavra-passe',
    currentPassword: 'Palavra-passe atual',
    newPassword: 'Nova palavra-passe',
  },
  auth: {
    loginTitle: 'Entrar',
    registerTitle: 'Criar conta',
    email: 'Email',
    password: 'Palavra-passe',
    forgotPassword: 'Esqueceste-te da palavra-passe?',
    login: 'Entrar',
    register: 'Registar',
    noAccount: 'Ainda não tens conta?',
    hasAccount: 'Já tens conta?',
    forgotTitle: 'Recuperar palavra-passe',
    forgotCta: 'Enviar email de recuperação',
    resetTitle: 'Definir nova palavra-passe',
    resetCta: 'Guardar nova palavra-passe',
    acceptTerms: 'Li e aceito os Termos e Condições e a Política de Privacidade',
    verifyTitle: 'Confirmar email',
    verifyLoading: 'A confirmar o teu email…',
    verifySuccess: 'Email confirmado! A tua conta está ativa. 💕',
    verifyError: 'Este link expirou ou já foi usado.',
    verifyMissingToken: 'Link inválido. Verifica o email que te enviámos.',
    verifyCtaAccount: 'Ir para a minha conta',
    verifyBannerText: 'Verifica o teu email para poderes finalizar encomendas.',
    verifyResend: 'Reenviar email',
    verifyResending: 'A reenviar…',
    verifyResent: 'Email reenviado. Verifica a tua caixa de entrada. ✨',
    verifyResendError: 'Não foi possível reenviar agora. Tenta de novo.',
    verifyCheckoutTitle: 'Confirma o teu email',
    verifyCheckoutLead:
      'Antes de finalizares a encomenda, confirma o teu email. Enviámos-te um link — verifica a tua caixa de entrada.',
  },
  orderStatus: {
    pending_payment: 'Aguarda pagamento',
    payment_processing: 'Pagamento em processamento',
    paid: 'Pago',
    preparing: 'A preparar',
    shipped: 'Expedido',
    delivered: 'Entregue',
    cancelled: 'Cancelado',
    refunded: 'Reembolsado',
  },
  paymentMethod: {
    mbway: 'MB WAY',
    multibanco: 'Multibanco',
    credit_card: 'Cartão de crédito',
    bank_transfer: 'Transferência bancária',
  },
  paymentStatus: {
    pending: 'Pendente',
    processing: 'Em processamento',
    paid: 'Pago',
    failed: 'Falhou',
    refunded: 'Reembolsado',
  },
  cookies: {
    title: 'Cookies e privacidade',
    body: 'Utilizamos cookies essenciais para o funcionamento do site. Cookies adicionais só são ativados depois de dares a tua autorização.',
    accept: 'Aceitar tudo',
    reject: 'Rejeitar',
    manage: 'Gerir preferências',
  },
  admin: {
    dashboard: 'Painel',
    greeting: 'Olá',
    weekly: 'Semanal',
    kpis: {
      totalSales: 'Vendas totais',
      ordersReceived: 'Encomendas recebidas',
      pendingOrders: 'Encomendas pendentes',
      newCustomers: 'Novas clientes',
      needsAttention: 'Precisam de atenção',
      vsLastWeek: 'vs. semana anterior',
    },
    sections: {
      salesWeek: 'Vendas da semana',
      thisWeek: 'Esta semana',
      lastWeek: 'Semana passada',
      recentOrders: 'Encomendas recentes',
      viewAll: 'Ver todas',
      topProducts: 'Mais vendidas',
      viewProducts: 'Ver produtos',
      unitsSold: 'vendas',
      customers: 'Clientes',
      viewCustomers: 'Ver clientes',
      totalCustomers: 'Total de clientes',
      newThisMonth: 'Novas este mês',
      returning: 'Voltaram a comprar',
      retentionRate: 'Taxa de fidelização',
      empty: 'Sem dados para mostrar.',
    },
    actions: {
      addProduct: 'Adicionar produto',
      viewOrders: 'Ver encomendas',
    },
    roles: {
      super_admin: 'Administradora',
      admin: 'Administradora',
      store_manager: 'Gestora de loja',
      customer: 'Cliente',
    },
    logout: 'Terminar sessão',
    backToStore: 'Voltar à loja',
  },
  errors: {
    generic: 'Ocorreu um erro. Por favor tente novamente.',
    network: 'Problema de ligação. Verifique a sua internet.',
    unauthorized: 'Sessão expirada. Inicie sessão novamente.',
  },
  validation: {
    required: 'Este campo é obrigatório.',
    email: 'Introduz um email válido.',
    phone: 'Introduz um número de telemóvel válido (9 dígitos).',
    postalCode: 'Código postal inválido. Usa o formato 0000-000.',
    nif: 'NIF inválido. Deve ter 9 dígitos.',
    minLength: 'Tem de ter pelo menos {n} caracteres.',
    passwordMin: 'A palavra-passe tem de ter pelo menos 8 caracteres.',
    passwordsDoNotMatch: 'As palavras-passe não coincidem.',
    acceptTerms: 'Tens de aceitar os termos e condições.',
  },
  footer: {
    shopColTitle: 'LOJA',
    shopLinkNew: 'Novidades',
    shopLinkAll: 'Todos os produtos',
    helpColTitle: 'INFORMAÇÃO',
    helpLinkTerms: 'Termos e Condições',
    helpLinkPrivacy: 'Política de Privacidade',
    helpLinkReturns: 'Entregas e Devoluções',
    helpLinkShipping: 'Estado de Encomenda',
    legalColTitle: 'LEGAL',
    legalLinkInfo: 'Informação Legal',
    legalLinkSale: 'Condições de Venda',
    legalLinkCookies: 'Política de Cookies',
    legalLinkComplaints: 'Livro de Reclamações',
    legalLinkDisputes: 'Resolução de Litígios',
    aboutColTitle: 'A ROSITA',
    aboutLinkStory: 'Sobre a Rosita',
    contactColTitle: 'PRECISAS DE FALAR COMIGO?',
    contactLead: 'Envia um e-mail para',
    contactEmail: 'info@rositastore.pt',
    contactReply: 'Vou responder o mais rápido possível.',
    socialColTitle: 'SEGUE-ME',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    facebook: 'Facebook',
    newsletterEyebrow: 'NEWSLETTER',
    newsletterTitle: '10% DE DESCONTO PARA AS NOVAS ROSITAS. REGISTA-TE JÁ!',
    newsletterBody: 'Sê a primeira a saber das novidades e promoções.',
    newsletterPlaceholder: 'Insere o teu e-mail!',
    newsletterCta: 'Subscrever',
    copyright: 'RositaStore. Todos os direitos reservados.',
    // Agency credit in the footer bottom bar; the name itself comes from the
    // Pixel Start wordmark rendered next to it.
    credit: 'Desenvolvido por',
    creditAgency: 'Pixel Start',
  },
  deliveries: {
    // Labels for the shipping table on /entregas-e-devolucoes. The values come
    // from the zones and rates configured in the backoffice.
    ratesTitle: 'Custos e prazos de entrega',
    colService: 'Serviço',
    colWeight: 'Peso',
    colPrice: 'Custo',
    colEstimate: 'Prazo estimado',
    estimateFallback: 'A confirmar',
    freeFrom: 'Portes grátis em encomendas a partir de {amount}.',
    zoneNoRates: 'Sem portes configurados para esta zona neste momento.',
    ratesEmpty:
      'A tabela de portes está a ser atualizada. Escreve-me e digo-te o custo exato para a tua morada.',
    ratesError:
      'Não consegui carregar a tabela de portes agora. Tenta outra vez daqui a pouco ou escreve-me.',
    ratesLoading: 'A carregar os portes…',
  },
  maintenance: {
    eyebrow: 'EM MANUTENÇÃO',
    title: 'Voltamos já',
    message:
      'Estamos a preparar novidades para ti. A loja volta a estar disponível muito em breve — obrigada pela tua paciência.',
    contactLead: 'Tens alguma questão? Escreve-me para',
    contactEmail: 'info@rositastore.pt',
  },
} as const;

export type Translations = typeof t;
